import React from 'react';

import { getLabel } from 'utils/getLabel';
import { get } from 'lodash';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { sectionTitle as SectionTitle } from 'ui/views/generic/sectionTitle';
 *
 * // render
 * <SectionTitle propName='propValue'/>
 */
export const sectionTitle = ( props ) => {
    return (
        <div className='ui-section-title'>

                { /* title for the modal */ }
                <div className='ui-section-title__title'>
					{ getLabel( get( props, 'config.title', {} ) ) }
				</div>
        </div>
    );
};

// set display name
sectionTitle.displayName = 'sectionTitle';

// set default props
sectionTitle.defaultProps = {};

// prop types
sectionTitle.propTypes = {};
